import { useState } from 'react';

import { FloatingTabs, Link } from '@dbt-labs/sourdough';

import { AppliedModelSortField, SortDirection } from '@/__generated__/graphql';
import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import { MartsSection } from './Marts';
import { ProducedPublicModels } from './ProducedPublicModels';

const tableModes = ['marts', 'producedPublicModels'] as const;
type TableMode = (typeof tableModes)[number];

export const PublicModelsAndMarts = () => {
  const [tableMode, setTableMode] = useState<TableMode>('marts');
  const displayTextMap: Record<TableMode, string> = {
    // each table should only containt 5 rows and link to filter view Replace "Load More" with "See All Marts Models"
    marts: 'Marts', // should link to models filter view filtered to marts name, tags, owner (links to group), lineage (link)
    producedPublicModels: 'Public models', // should link to models filter view filtered to public models, name, tags, owner, used in, lineage
  };

  const getModelFilterLink = useLinkToExplorer('resourceFilter');
  const { accountId, projectId, environmentType } = useUrlProjectParams();

  return (
    <div className="my-10">
      <div className="flex">
        <h2 className="mb-1 flex-1 text-base font-medium text-fgMain">
          Marts and public models
        </h2>
        <Link
          isInternal
          to={getModelFilterLink({
            accountId,
            environmentType,
            projectId,
            resourceType: 'model',
            sort: {
              direction: SortDirection.Desc,
              field: AppliedModelSortField.QueryUsageCount,
            },
          })}
          className="flex-0"
        >
          See all models
        </Link>
      </div>
      <div className="mb-4 mt-1">
        <FloatingTabs>
          {tableModes.map((mode) => (
            <FloatingTabs.Tab
              key={mode}
              id={mode}
              isActive={mode === tableMode}
              onClick={(): void => setTableMode(mode)}
            >
              {displayTextMap[mode]}
            </FloatingTabs.Tab>
          ))}
        </FloatingTabs>
      </div>
      <div>
        {tableMode === 'marts' && <MartsSection />}
        {tableMode === 'producedPublicModels' && <ProducedPublicModels />}
      </div>
    </div>
  );
};
